<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      <div class="dialog-title">{{ daialogTitle }}</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <h1>勤怠</h1>
        <h2>休暇</h2>
        <v-layout row wrap>
          <v-flex md5>
            <v-select
              v-model="value.holidayType"
              label="休暇申請"
              :items="dayTypes"
              attach
              :readonly="true"
            ></v-select>
          </v-flex>
        </v-layout>
        <div v-if="value.version > 1" style="margin-bottom: 1em">
          <h2>勤務一覧</h2>
          <v-layout row wrap>
            <working-hours-table
              :hours="value.working_hours ? value.working_hours : []"
              :readOnly="true"
            />
          </v-layout>
        </div>
        <v-layout row wrap>
          <v-flex md3>
            <h2>始業</h2>
          </v-flex>
          <v-flex md3>
            <h2>終業</h2>
          </v-flex>
          <v-flex md3>
            <h2>昼休憩</h2>
          </v-flex>
          <v-flex md3>
            <h2>その他休憩</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md2>
            <input-time v-model="value.start" :readonly="true" />
          </v-flex>
          <v-flex md2 offset-md1>
            <input-time v-model="value.end" :readonly="true" />
          </v-flex>
          <v-flex md2 offset-md1>
            <input-time
              :isBy10Minutes="true"
              :readonly="true"
              v-model="value.lunch"
            />
          </v-flex>
          <v-flex md2 offset-md1>
            <input-time
              :isBy10Minutes="true"
              :readonly="true"
              v-model="value.break"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3>
            <div class="new-line" v-if="value.reasonsForEditStart">
              修正理由：{{ value.reasonsForEditStart }}
            </div>
          </v-flex>
          <v-flex md3>
            <div class="new-line" v-if="value.reasonsForEditEnd">
              修正理由：{{ value.reasonsForEditEnd }}
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md3>
            <h2>在宅務時間</h2>
          </v-flex>
          <v-flex md3>
            <h2>非勤務時間</h2>
          </v-flex>
          <v-flex md3>
            <h2>実働</h2>
          </v-flex>
          <v-flex md3>
            <h2>深夜</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md2>
            <input-time
              :isBy10Minutes="true"
              v-model="value.total_home_working_hours"
              :readonly="true"
              v-if="value.total_home_working_hours"
            />
          </v-flex>
          <v-flex md2 offset-md1>
            <input-time
              :isBy10Minutes="true"
              v-model="value.total_nonworking_hours"
              :readonly="true"
            />
          </v-flex>
          <v-flex md2 offset-md1>
            <input-time
              :isBy10Minutes="true"
              v-model="working"
              :readonly="true"
            />
          </v-flex>
          <v-flex md2 offset-md1>
            <input-time
              :isBy10Minutes="true"
              v-model="lateNight"
              :readonly="true"
            />
          </v-flex>
        </v-layout>
        <h1>原価</h1>
        <v-layout row wrap>
          <v-flex md6>
            <table>
              <colgroup>
                <col style="width: 50%" />
                <col style="width: 40%" />
              </colgroup>
              <thead>
                <tr>
                  <th>クライアント名</th>
                  <th>時間</th>
                </tr>
              </thead>
              <tr v-for="cost in costs" :key="cost.client_name">
                <td>{{ cost.client_name }}</td>
                <td>
                  <input-time
                    :isBy10Minutes="true"
                    v-model="cost.time"
                    :readonly="true"
                  />
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
        <v-flex md2 offset-md4>
          <table>
            <tr>
              <th>原価時間合計</th>
            </tr>
            <tr>
              <td>
                <input-time
                  :isBy10Minutes="true"
                  v-model="sumOfCosts"
                  readonly
                />
              </td>
            </tr>
          </table>
        </v-flex>
        <template v-if="value.daily_commuting_allowance && value.daily_commuting_allowance > 0">
            <h1>通勤費</h1>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2>通勤経路</v-flex>
              <v-flex md4>
                <v-text-field
                  type="text"
                  v-model="value.daily_commuting_route"
                  readonly
                />
              </v-flex>
              <v-flex md1>通勤費</v-flex>
              <v-flex md2>
                <v-text-field
                  type="number"
                  v-model.number="value.daily_commuting_allowance"
                  suffix="円"
                  readonly
                />
              </v-flex>
            </v-layout>
          </template>
        <h1>経費</h1>

        <v-layout row wrap>
          <v-flex md12>
            <table>
              <colgroup>
                <col style="width: 30%" />
                <col style="width: 10%" />
                <col style="width: 10%" />
                <col style="width: 50%" />
              </colgroup>
              <thead>
                <tr>
                  <th>クライアント名</th>
                  <th>種別</th>
                  <th>金額</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tr v-for="(expense, i) in expenses" :key="i">
                <td>{{ expense.client_name }}</td>
                <td>{{ expense.type }}</td>
                <td>{{ expense.price }}</td>
                <td>{{ expense.note }}</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md2 offset-md10>
            <table>
              <tr>
                <th>経費合計</th>
              </tr>
              <tr>
                <td>{{ sumOfExpenses }}</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
        <h1>備考</h1>
        <v-layout row wrap>
          <v-flex sm12 md8>
            <v-textarea
              v-model="value.note"
              label="備考"
              auto-grow
              readonly
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue" class="white--text" @click="closeDialog"
        >閉じる</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import db from "@/components/firebaseInit";
import InputTime from "@/components/inputTime";
import { mapMutations, mapGetters, mapActions } from "vuex";
import WorkingHoursTable from "@/components/EditTimecard/workingHoursTable";

var moment = require("moment-timezone");
moment.tz.setDefault("Asia/Tokyo");

export default {
  components: {
    InputTime,
    WorkingHoursTable,
  },
  props: ["value", "calender"],
  data: () => ({
    dbRef: db.collection("clients"),
    dbRefUser: db.collection("users"),
    dialog: false,
    dayTypes: ["", "有休", "半休", "無給", "欠勤", "半欠勤", "振休","振休(所定休)", "振出","特別有休（M休やV休）",
      "産前休",
      "産後休",
      "育児休",
      "介護休",
      "休職",
      "その他休"],
    editable: false,
    costs: [],
    clients: [],
    costClient: "",
    costClientError: "",
    expenses: [
      {
        client_id: "000",
        client_name: "社内",
        type: "営業交通費",
        price: 3600,
        note: "",
      },
    ],
    expense: {
      client_id: "",
      client_name: "",
      type: "営業交通費",
      price: 0,
      note: "",
    },
    expenseType: ["営業交通費", "その他"],
    expenseErros: [],
    worktimeErrors: [],
    reasonError: "",
    workstartBackup: 0,
    workendBackup: 0,
    timecardError: "",
    profile: {},
  }),
  mounted() {
    this.expenses = this.value.expenses ? this.value.expenses : [];
    this.costs = this.value.costs ? this.value.costs : [];
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    isValidTimeCard() {
      const differenceTime = this.sumOfCosts - this.working;
      return differenceTime <= 6000 && differenceTime >= -6000;
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
  computed: {
    working() {
      let worktime = 0;
      if (this.value.end && this.value.end > 0) {
        worktime =
          this.value.end -
          this.value.start -
          this.value.lunch -
          this.value.break -
          (this.value.total_nonworking_hours
            ? this.value.total_nonworking_hours
            : 0);
      } else {
        worktime = null;
      }
      if (worktime < 0) {
        this.worktimeErrors.push("実働時間がマイナスです。");
      } else {
        this.worktimeErrors = [];
      }
      return worktime;
    },
    lateNight() {
      const lateNightTime = 22 * 3600;
      return this.value.end - lateNightTime <= 0
        ? 0
        : this.value.end - lateNightTime;
    },
    isReason() {
      return this.value.reason && this.value.reason.length > 0;
    },
    daialogTitle() {
      const date = this.value.date_id;
      return date + " " + this.value.owner_name + " タイムカード";
    },
    endtimeIsValid() {
      return (
        this.value.end -
          this.value.start -
          this.value.lunch -
          this.value.break >
        0
      );
    },

    sumOfExpenses() {
      let sum = 0;
      this.expenses.forEach((e) => {
        sum = sum + Number(e.price);
      });
      return sum;
    },
    sumOfCosts() {
      let sum = 0;
      this.costs.forEach((c) => {
        sum = sum + Number(c.time);
      });
      return sum;
    },
    ...mapGetters("auth", ["user"]),
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  display: inline-block;
}
h2 {
  color: #ff5722;
  margin: 0px;
}
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  table-layout: fixed;
  font-size: 9pt;
  width: 100%;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid gray;
  }
  td {
    word-wrap: break-word;
    padding: 5pt;
  }
  tr {
    height: 10mm;
  }
  td.delete-cell {
    text-align: center;
    padding: 0px;
  }
}
.multi-line {
  white-space: pre-line;
}
.align-right {
  text-align: right;
  padding-right: 0px;
}
</style>